import Vue from 'vue';
import Router from 'vue-router';
import Top from '../views/Top';
import SitePolicy from '../views/policy/SitePolicy';
import PrivacyPolicy from '../views/policy/PrivacyPolicy';
import PrivacyPolicyEn from '../views/policy/PrivacyPolicy_en';
import HowToPlay from '../views/HowToPlay';
import NoticeList from '../views/NoticeList';
import GalleryList from '../views/GalleryList';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    /** ホーム画面 */
    {
      path: '/',
      name: 'Top',
      component: Top
    },
    /** プライバシーポリシー */
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    /** プライバシーポリシー */
    {
      path: '/privacy-policy-en',
      name: 'PrivacyPolicy-en',
      component: PrivacyPolicyEn
    },
    /** サイトポリシー */
    {
      path: '/site-policy',
      name: 'SitePolicy',
      component: SitePolicy
    },
    /** 遊びかた */
    {
      path: '/how-to-play',
      name: 'HowToPlay',
      component: HowToPlay
    },
    /** おしらせ */
    {
      path: '/notice-list',
      name: 'NoticeList',
      component: NoticeList
    },
    /** ギャラリー */
    {
      path: '/gallery-list',
      name: 'GalleryList',
      component: GalleryList
    }
  ],

  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
